import api from "api/api";

// Fast & Furious — candidate qualifications, mission service.
// Creation: candidate + email + need reference (need_id XOR new_need), no status.
// Weekly review: dedicated routes per declaration (GET list + PATCH answer).

// Qualifs attached to one/several declaration(s) (declaration_ids required,
// otherwise 400 qualif_filter_required). Feeds the recap counter AND the edit list.
export const getQualifsByDeclarationQuery = async (declarationId) =>
  await api.get(`/mission/qualif?declaration_ids=${declarationId}`);

export const createQualifQuery = async ({ payload }) =>
  await api.post(`/mission/qualif`, payload);

// Deleting a qualif: back-gated (owner + created in the current
// week + no review dependency); no body, no query-param.
export const deleteQualifQuery = async ({ id }) =>
  await api.delete(`/mission/qualif/${id}`);

// List of qualifs to review for the current declaration:
// [{ qualif, status, qualification_date }] (status = null until answered).
export const getQualifReviewsQuery = async (declarationId) =>
  await api.get(`/mission/qualif-review/${declarationId}`);

// Saves/updates the review answer for a qualif (upsert):
// { qualif_id, status, qualification_date } — date required if status = Q2.
export const patchQualifReviewQuery = async ({ declarationId, payload }) =>
  await api.patch(`/mission/qualif-review/${declarationId}`, payload);
